import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  uploadBytesResumable,
  uploadString,
} from "firebase/storage";
import { v4 as uuid } from "uuid";


const srcUpload = async (store, name, imgUpload) => {
  const sotrageRef = ref(store, `images/${name}`);
  const uploadTask = uploadBytesResumable(sotrageRef, imgUpload);
  return new Promise((resolve, reject) => {
   uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      //   const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      //   console.log("Upload is " + progress + "% done");
      //   switch (snapshot.state) {
      //     case "paused":
      //       console.log("Upload is paused");
      //       break;
      //     case "running":
      //       console.log("Upload is running");
      //       break;
      //     default:
      //       console.log("run default");
      //   }
      },
      (error) => {
        // Handle unsuccessful uploads
        console.log("error upload src", error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          resolve(downloadURL)
        });
      }
    );
  })
};


const predictUpload =  async (store,name,preImg)=>{
   const sotrageRef = ref(store, `images/${name}`);
   
  return new Promise((resolve)=>{
   uploadString(sotrageRef, preImg, 'data_url').then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
      resolve(downloadURL)
   })
   
       });
  })
}
export { srcUpload ,predictUpload};
